<template lang="pug">
.form-group(:class='{ "form-success--": search }')
  ed-input-tooltip(v-if='helptipBody && focused || helptipBody && error'
                  :class='{ "error-message" : error }'
                  :helptipHeader='helptipHeader'
                  :errorTip='error'
                  :helptipBody='helptipBody'
                )
  label(v-if='fieldLabel') {{ fieldLabel }}
    span(v-if='required') &nbsp*
  input.form-control(
    :autofocus='autofocus'
    :dir='setDir'
    :required='required'
    :type='type'
    :value='value'
    v-bind='$props'
    v-focus.lazy='autofocus'
    @focus='emitFocus'
    @blur='emitBlur'
    @input='updateValue($event.target.value)'
    @change='$emit("change", $event.target.value)'
    ref='input'
    :style='symbolWidth'
  )
  span.toggle-password-icon(v-if='showPassword' @click='togglePassword')
      i.fal.fa-eye(v-if='fieldType === "password"')
      i.fal.fa-eye-slash(v-if='fieldType === "text"')
  span.search-icon(v-if='search')
    i.fa.fa-search
  span.dawn-input-number-symbol(v-if='symbol') {{ symbol }}
  small.form-text.text-muted(v-if='helpText') {{ helpText }}
</template>

<script>

import EdInputTooltip from '@/core/components/edInputTooltip/index.vue'

export default {
  name: 'ed-input',
  props: {
    fieldLabel: String,
    type: {
      type: String,
      default: 'text'
    },
    dir: String,
    required: Boolean,
    autofocus: Boolean,
    name: String,
    disabled: Boolean,
    error: Boolean,
    placeholder: String,
    value: [String, Number],
    helpText: String,
    showPassword: Boolean,
    helptipHeader: String,
    helptipBody: String,
    symbol: String,
    search: Boolean
  },
  components: {
    'ed-input-tooltip': EdInputTooltip
  },
  directives: {
    focus: {
      inserted: function (el, binding) {
        if (binding.value) el.focus()
        else el.blur()
      },
      componentUpdated: function (el, binding) {
        if (binding.modifiers.lazy) {
          if (Boolean(binding.value) === Boolean(binding.oldValue)) {
            return
          }
        }
        if (binding.value) el.focus()
        else el.blur()
      }
    }
  },
  data () {
    return {
      focused: false,
      fieldType: this.type,
      symbolWidth: ''
    }
  },
  computed: {
    setDir () {
      if (this.type === 'number' && this.dir !== 'ltr') {
        return 'rtl'
      } else {
        return 'ltr'
      }
    },
    setType () {
      return this.fieldType
    }
  },
  methods: {
    getSymbolPadding () {
      if (this.symbol) {
        var symbolHolder = this.$refs.symbolWrapper.clientWidth + 10
        this.symbolWidth = 'paddingRight: ' + symbolHolder + 'px'
      }
    },
    updateValue (value) {
      this.$emit('input', value)
    },
    togglePassword () {
      this.fieldType = this.fieldType === 'password' ? 'text' : 'password'
      this.$refs.input.setAttribute('type', this.fieldType)
      this.$refs.input.focus()
    },
    emitBlur (event) {
      this.$emit('focus', event.target.value)
      this.focused = false
    },
    emitFocus (event) {
      this.$emit('focus', event.target.value)
      this.focused = true
      this.getSymbolPadding()
    }
  }
}
</script>

<style scoped lang='scss'>
@import "~@/assets/sass/_variables.scss";
@import "~@/assets/sass/_form_fields.scss";

.form-group {
  position: relative;
}

.form-control,
.form-group .form-control {
  @include form-field;
}

.form-control[search] {
  background: none;
  border: none;
  box-shadow: none;
  border-bottom: 1px solid $background;
  &:focus {
    border-width: 0 0 1px 0;
    box-shadow: none;
  }
}

.symbol-holder {
  display: inline-block;
  height: 100%;
  position: absolute;
  right: 2%;
  top: 40%;
  z-index: 1;
  padding: .5rem .5rem .5rem 0rem;
  font-size: $font-size-small;
  line-height:1.8;
}

// search input
.theme.skin .form-control[search] {
  padding-left: 2em;

  &+.search-icon {
    position: absolute;
    left: 0.4em;
    bottom: 0.1em;
    color: $ink;
  }
}

.dawn-input-number-symbol {
  display: inline-block;
  position: absolute;
  right: 14px;
  top: 33px;
  font-size: $font-size-base - 2px;
  color: $ink;
  font-weight: $font-weight-bold;
}

.toggle-password-icon {
  color: $background;
  display: inline-block;
  height: 100%;
  position: absolute;
  right: 2%;
  top: 40%;
  z-index: 1;
  padding: .5rem;
  transition: all .5s ease-out;

  &:hover {
    cursor: pointer;
    color: $primary-05;
  }
}

</style>



// WEBPACK FOOTER //
// index.vue?51b67d9c